import { render, staticRenderFns } from "./CytomineDescription.vue?vue&type=template&id=2748159c&scoped=true"
import script from "./CytomineDescription.vue?vue&type=script&lang=js"
export * from "./CytomineDescription.vue?vue&type=script&lang=js"
import style0 from "./CytomineDescription.vue?vue&type=style&index=0&id=2748159c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2748159c",
  null
  
)

export default component.exports